import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTradingViewCandles: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTradingViewCandles"><Path d="M8 2H6V9H3V19H6V22H8V19H11V9H8V2Z" fill="currentColor"/><Path d="M18 2H16V5H13V19H16V22H18V19H21V5H18V2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTradingViewCandles;
